import { obterParametrosDaURL } from "../../../../functions";
import { IResponderSolicitacao } from "../../../../interfaces";
import { api } from "../../api";
import { ApiException } from "../../api-exception";

export const ResponderSolicitacao = async (
  body: IResponderSolicitacao,
) => {
  const { token } = obterParametrosDaURL();

  try {
    await api.put(`/autorizarsolicitacaosenha`, body, { headers: { token } });
  } catch (erro) {
    throw new ApiException(
        erro,
        "Erro ao responder solicitação"
    );
  }
};